<template>
  <div class="register-wrap">
    <Nav only />
    <Register
      title="New to Movingkite"
      @login="login"
      @login-success="loginSuccess"
      @register-success="registerSuccess"
    />
  </div>
</template>

<script>
import Register from './Register';
import Nav from '../../components/comm/Nav';
export default {
  components: {
    Register,
    Nav,
  },
  methods: {
    login() {
      this.$router.push('login');
    },
    registerSuccess() {
      this.$router.replace('/login');
    },
    loginSuccess() {
      let { query } = this.$route;
      if (query.back) {
        this.$router.back();
      } else {
        this.$router.replace(query.backurl || '/user/order');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.register-wrap {
  background-color: #fff;
  padding-bottom: 40px;
  padding-top: 210px;
}
</style>
